import Vue from "vue";
import Router from "vue-router";
import Client from "../views/Client.vue";
import TripList from "../views/TripList.vue";
import Menu from "../views/Menu.vue";
import Trip from "../views/Trip.vue";
import Favori from "../views/Favori.vue";
import Historique from "../views/Historique.vue";
import FavoriteList from "../views/FavoriteList.vue";
import Signin from "../views/Signin.vue";
import Signup from "../views/Signup.vue";
import Reset from "../views/Reset.vue";
import Invitation from "../views/Invitation.vue";
import Password from "../views/Password.vue";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Menu",
      component: Menu,
    },
    {
      path: "/client",
      name: "Client",
      component: Client,
    },
    {
      path: "/triplist",
      name: "TripList",
      component: TripList,
    },
    {
      path: "/trip/:id",
      name: "trip",
      component: Trip,
    },
    {
      path: "/historique",
      name: "historique",
      component: Historique,
    },
    {
      path: "/favori",
      name: "favori",
      component: Favori,
    },
    {
      path: "/favoriteList",
      name: "favoriteList",
      component: FavoriteList,
    },
    {
      path: "/signin",
      name: "Signin",
      component: Signin,
    },
    {
      path: "/signup",
      name: "Signup",
      component: Signup,
    },
    {
      path: "/reset",
      name: "Reset",
      component: Reset,
    },
    {
      path: "/invitation",
      name: "Invitation",
      component: Invitation,
    },
    {
      path: "/password",
      name: "Password",
      component: Password,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  let baseUrl = "/" + to.path.toLowerCase().split("/")[1];
  baseUrl = baseUrl.split("?")[0];
  const publicPages = [
    "/signin",
    "/signup",
    "/password",
    "/invitation",
    "/reset",
  ];
  const authRequired = !publicPages.includes(baseUrl);
  const loggedIn = localStorage.getItem("user");
  if (authRequired && !loggedIn) {
    return next("/signin?redirectUri=" + window.location.href);
  }
  next();
});
